import React, { useState, useEffect, useMemo } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { AuthProvider } from '../auth/auth_context';
import getTheme from '../layout/theme';
import AuthenticatedRouter from './authenticated_router';

const drawerSize = { width: 220, widthClosed: 72 };

function AppRouter() {
  const [isOpen, setIsOpen] = useState(true);
  const toggleNav = () => setIsOpen(prev => !prev);
  const [mode, setMode] = useState('light');
  const theme = useMemo(() => getTheme(mode), [mode]);
  const toggleMode = () => setMode(prevMode => (prevMode === 'light' ? 'dark' : 'light'));
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    const checkIfScrolledToBottom = () => {
      const bottomReached =
        window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 1;
      setIsAtBottom(bottomReached);
    };

    window.addEventListener('scroll', checkIfScrolledToBottom);
    checkIfScrolledToBottom();
    return () => window.removeEventListener('scroll', checkIfScrolledToBottom);
  }, []);

  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <Router>
          <AuthenticatedRouter
            isOpen={isOpen}
            toggleNav={toggleNav}
            isAtBottom={isAtBottom}
            mode={mode}
            toggleMode={toggleMode}
            drawerSize={drawerSize}
          />
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default AppRouter;